import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import AppHeader from './layout/AppHeader.jsx';

const NAV = [
  { to: '/hr/employees', label: 'Employees', perm: ['employee', 'list'] },
  { to: '/hr/org-chart', label: 'Org Chart', perm: ['employee', 'read'] },
  { to: '/hr/attendance', label: 'Attendance', perm: ['attendance', 'list'] },
  { to: '/hr/leave', label: 'Leave', perm: null },
  { to: '/hr/payroll', label: 'Payroll', perm: ['payroll_run', 'list'] },
  { to: '/hr/performance', label: 'Performance', perm: null },
  { to: '/hr/me', label: 'My Profile', perm: null },
];

export default function HrShell() {
  const { can, roles } = useAuth();
  const visible = NAV.filter((n) => !n.perm || roles.includes('super_admin') || can(n.perm[0], n.perm[1]) || ['/hr/leave', '/hr/performance', '/hr/me'].includes(n.to));

  return (
    <div className="hr-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">HRIS</div>
          <ul>
            {visible.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
